export default __webpack_public_path__ + "static/media/green.b1939455.svg";